// extracted by mini-css-extract-plugin
var _1 = "IntegrationsConflictQueue-modulebody__vMLA1";
var _2 = "IntegrationsConflictQueue-moduleskeleton__YdA_1";
export { _1 as "body", _2 as "skeleton" }
